import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A few thoughts on blogging inspiration",
  "description": "",
  "published": "2012-04-05T00:00:00.000Z",
  "redirect_from": ["/blog/a-few-thoughts-on-blogging-inspiration/swizec/4119"],
  "categories": "blog, Idea, Twitter, Uncategorized, Writing, Zemanta",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}><a parentName="p" {...{
          "href": "https://twitter.com/gstritar"
        }}>{`@gstritar`}</a>{` yep, using Blogspire. Have you tried blogging about a topic that isn't "yours"? It takes _hours_. /`}<a parentName="p" {...{
          "href": "https://twitter.com/zemanta"
        }}>{`@zemanta`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/187864436076331008"
      }}>{`April 5, 2012`}</a></blockquote>
    <p><a parentName="p" {...{
        "href": "http://blogspire.zemanta.com/"
      }}>{`Blogspire`}</a>{` `}<em parentName="p">{`is`}</em>{` a great suggestion tool - go sign up ;) - but when a topic doesn't come from within the process to coming up with a post is a lot more complicated. Even when the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Idea",
        "title": "Idea"
      }}>{`idea`}</a>{` `}<strong parentName="p"><em parentName="strong">{`is`}</em></strong>{` yours, there is a lot that goes into coming up with a decent post.`}</p>
    <p>{`Let me describe the two ways I write.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "300px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a277370d3e658fce6a3cb119568b32fa/f93b5/Meadow-near-Gards-Farm-Taken-from-the-bridlew2aadj3.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M388%20102l-7%205-7%204-1-3c2-7-2-9-10-5-7%204-7%204-6%208%200%203%200%203-2%202-2-3-5-2-7%201l-1%202-1-2c-2-3-4-3-13-1l-6-1c-4-3-10-2-11%200-2%202-6%202-14%200h-7c-2-3-12-2-15%202l-5%201a231%20231%200%2000-40%203l-3%202a1009%201009%200%2001-5%202c-1%202-1%203-3%202l-5%201c-2%202-8%202-10%200l-3-2-3-1c-2-2-9-2-11%200s-4%202-6%201c-1-2-4-2-7-1l-7%202c-4%201-4%200-8-3-4-5-6-5-9-1-3%203-3%203-2%201l-1-2-2-1c-1-2-6%201-7%204%200%202-1%202-6%202-14%200-17%200-17-2%200-5-7-8-15-5-4%201-7%201-12-1-4-2-4-2-7%200l-7%202-5%201-2-1c-2-3-15%200-21%206l-4%203-2-2c-2-2-10-3-14-1s-7%200-7-3c0-4-3-6-8-6-5-1-8%200-6%203%201%201%200%202-3%204-2%202-3%203-2%204%200%202%200%202-2%202H0v11l1%2013v4l-1%204c0%202%200%203%202%203l1%201H2c-2%200-2%201-2%209l1%2010v1l-1%2059v57h401v-76l-1-100V99h-3l-9%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a277370d3e658fce6a3cb119568b32fa/ca0a1/Meadow-near-Gards-Farm-Taken-from-the-bridlew2aadj3.webp 223w", "/static/a277370d3e658fce6a3cb119568b32fa/c85cb/Meadow-near-Gards-Farm-Taken-from-the-bridlew2aadj3.webp 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a277370d3e658fce6a3cb119568b32fa/853b2/Meadow-near-Gards-Farm-Taken-from-the-bridlew2aadj3.jpg 223w", "/static/a277370d3e658fce6a3cb119568b32fa/f93b5/Meadow-near-Gards-Farm-Taken-from-the-bridlew2aadj3.jpg 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a277370d3e658fce6a3cb119568b32fa/f93b5/Meadow-near-Gards-Farm-Taken-from-the-bridlew2aadj3.jpg",
                "alt": "Meadow near Gard's Farm Taken from the bridlew...",
                "title": "Meadow near Gard's Farm Taken from the bridlew...",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Meadow near Gard's Farm Taken from the bridlew...`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "my-post"
    }}>{`"my" post`}</h2>
    <p>{`When `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Writing",
        "title": "Writing"
      }}>{`writing`}</a>{` in a creative flurry, everything is simple (this only happens when you have plenty of free time)`}</p>
    <ol>
      <li parentName="ol">{`Get idea`}</li>
      <li parentName="ol">{`Become antsy to write about it`}</li>
      <li parentName="ol">{`Keep thinking about the idea while working out, under the shower, during breakfast`}</li>
      <li parentName="ol">{`Jump into a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Text_editor",
          "title": "Text editor"
        }}>{`text editor`}</a></li>
      <li parentName="ol">{`Write like a mad man`}</li>
      <li parentName="ol">{`Breathe`}</li>
      <li parentName="ol">{`Edit a bit (30% rewrite)`}</li>
      <li parentName="ol">{`Publish`}</li>
    </ol>
    <p>{`That's it. Another post is born.`}</p>
    <p>{`This type of post feels very good to write, gets something off my mind and occasionally reaches some level of popularity on the hackernewses and such out there.`}</p>
    <p>{`Usually these posts are flops in the traditional sense. The only post of this sort that has ever reached popularity was `}<em parentName="p"><a parentName="em" {...{
          "href": "http://swizec.com/blog/living-life-in-25min-increments/swizec/1859"
        }}>{`Living life in 25 min increments`}</a>{`.`}</em></p>
    <h2 {...{
      "id": "not-my-post"
    }}>{`"not my" post`}</h2>
    <p>{`More often than not, you can't write a post the moment you think of it. You're either too busy, the idea hasn't fully formed in your head, or it just isn't the right type of idea for a particular day.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "300px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/546c1c603cfde02b8227ea9f9debca40/f93b5/Sunset-behind-the-remaining-three-of-Bristolsdjb52j.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2092l1%2092h3l4-1%2015-3c1%200%202-1%201-4%200-3%200-3%204-3l4%202%204%201c3%200%203%200%203%202%200%205%202%208%205%209l3%201h1c1-2%201-2%203-1%201%201%202%201%204-2s5-3%204%200c-1%201%200%202%204%202%202%201%203%201%203-1%201-2%202-3%204-3l4-1h5c5%200%205-1%207-4%201-3%202-3%205-3l5-1%203-2c2%200%202%200%201-1v-3c0-2%201-2%203-1%201%202%202%202%204%201s2-4%200-3l-3-1-3-2v-1l2-1c-2-4%202-3%206%202%208%208%208%209%204%2011-4%201-4%202-3%205%200%205-2%2010-4%208-2-1-7%200-7%201l-6%203c-5%201-6%203-1%204%202%200%202%201%201%201-2%201-3%203%200%203l1-1%204-1%204-2c1-1%202-2%203-1%203%201%205-1%204-2-1-2-1-3%201-6%203-4%203-5%202-7-1-3-1-3%202-4%203-2%203-2%207%204%204%205%205%206%205%2012l2%2013%201%2011v5h-7c-8%200-12-1-12-4%200-2-4-1-5%201-2%202-3%202-18%202-9%200-9%200-9-2%202-5-3-8-7-4-2%201-4%201-4-2l-1-2-2%202-1%201-1-2-1-2-1%202h-1c-1-1-1-1-1%201l-1%203c-1%201%200%203%202%203v-1l1-2%201%201%201%202c0%202-1%202-4%202-6%200-7-1-6-4v-4c-1-2-3%200-3%203%201%202%200%203-2%203-4%201-7%200-7-2%200-3-4-6-6-6h-6c-2-1-3-1-4%201-3%202-9%202-9%200-1-2-4-3-7-2l-5%202-3%201v57h401l-1-40v-40c-2-1-10%205-12%208%200%202-2%204-3%205l-2%204-1%201-15%202-7%201c-7%201-11%203-12%205-1%205-5%206-5%202%200-3-7-10-11-10-5%200-11%202-13%205l-5%202-3%201c-1%201-1%201-3-1l-1-2-3%203-3%203-2-2c-4-4-6-4-10%200-3%202-3%202-4%200-1-3-3-4-4-2-1%201-3%202-4%201-5-1-9-6-6-6v-1l-2-2c0-1-2-2-6-2-5-1-5-1-8%202-5%203-5%204-4%206%200%202-4%205-7%205l-2%202c-1%202-5%200-8-3l-3-3-2%202c-1%202-3%202-6%202a218%20218%200%20011-49c-1-2%200-16%201-17l4-3-3%201c-2%200-2-1-2-3%200-3%201-5%202-3l3%201c2%200%204%203%203%205l5%204v-5l2-1h2c1%201%202%202%203%201l3%201%204%203c3%201%204%201%203%203%200%204%201%204%206%203%204-2%205-3%202-3-4-2-2-3%203-3%204%201%205%200%205-1%201-2%201-2-2-2-2%200-3%200-3-2l-1-1c-2%200-2-1-2-3s-2-4-4-4l-2-1c0-4-1-5-3-4h-5c-4%200-5-2-4-7%201-3%202-4%203-3%202%201%204%200%203-1h-1l-1-1%201-1c2-1%202%200%203%201l2%202c2%200%204%202%202%202l-1%202%202-1c1-1%201-1%201%201s2%204%203%202v-1c-3-2%200-7%203-5l4-2%201-2-1-1c0-2%202-1%204%201%201%201%202%203%201%204%200%203%201%203%203%200%202-2%204-3%205-1l-2%201c-2%200-3%202-1%204l3-2%202-1%201%201%203%202%204%201c2%200%202%200%201%201-1%202-2%202-4%200h-3l3%203c4%202%207%201%207-3v-4c0-2%200-2-2-2s-3-1-3-2l-2-1-5-2c-2-3-2-3%200-4l3-1h3v-2c-3%201-2-1%201-4%203-2%203-3%202-3-2%200-2%200-1-1v-4l2%201%201%201v-1c-1-2-1-2%201-2l4-2%207-2%206-1%203-2%202-1%207-4c5-1%208-3%209-4l4-1%204-1%202-1%203-2%204-1c3%201%2011%200%2018-3%203-1%204-1%207%201%203%201%203%201%208-2s7-4%207-1c0%202%201%202%204%202h4c1%200%202%2013%202%2056%200%2050%201%2047%201-37V0H0v92m221%2022c1%203%201%203-1%202-2-2-2-2-4%200l-2%201-2-1-2-1-1-2-1%201%205%2010%202%204%203%203%201%201c1%201%201%201%203-1%201-1%202-2%203-1h1v-15l-3-2c-2-1-2-1-2%201m-34%203l1%202c1%201%200%201-1%201h-3l-4%201c-5%200-11%202-12%203l-6%202-8%201h-5l-4%201c-4%200-12%205-12%207l-1%201-1-2-1-2-2-2-1-2v4a729%20729%200%20018%2068l3%2013%202%203c0%202%207%203%209%201l4-1c3%200%205%202%203%204s-1%203%201%203c3-1%206%201%206%203%200%203%201%202%203%200%200-2%201-2%204-2%202%200%203-1%203-2l-2-2c-1-4%2010-4%2012-1%201%202%206-1%206-2l1-2%201-1c0-1%201-2%202-1l2-1%203-1c3%200%203-1%203-18%200-15-1-15-3-15-1%200-2%200-1-2l-1-2-1-1%202-1c2%200%203%200%203-3s-1-4-3-1c-5%205-11%209-11%206h2l1-1-3-2c-2%200-3-1%200-3l1-3%201-2%201-2c1-2%201-2%204-2%203%201%206-1%206-3l2-1c4%201%203-2%200-2l-3-2%201-1%203-1c3-3%203-4%203-7a412%20412%200%2001-4-24c-2-1-5-1-5%201h-2c0-2-1-2-1-1h-2l-2-1-1-2-1%202m-74%2016l1%206-1%202c0%202-1%203-7%203-7%200-7%200-7%202%201%203%206%204%2013%203h7l-1-3c0-6-3-13-5-14v1m96%209c-2%205%201%208%206%206h3c1%201-2%203-4%204l-4%202c-2%202-2%202-1%203l2%203%201%201c1-1%202%200%202%201%201%202%201%202-2%201h-2l2%202%202%202%204%203%201-15c0-15%200-16-7-16-2%200-3%200-3%203m-102%2010l6%208%208%2011c3%205%204%202%200-9l-3-10-5-1-6%201m102%2019v3c-2%201-2%205-3%2020%200%2010%201%2015%202%2016s1%201%201-1l1-3c1%200%204%203%204%205%202%204%202%201%203-9a1802%201802%200%2001-1-31h-7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/546c1c603cfde02b8227ea9f9debca40/ca0a1/Sunset-behind-the-remaining-three-of-Bristolsdjb52j.webp 223w", "/static/546c1c603cfde02b8227ea9f9debca40/c85cb/Sunset-behind-the-remaining-three-of-Bristolsdjb52j.webp 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/546c1c603cfde02b8227ea9f9debca40/853b2/Sunset-behind-the-remaining-three-of-Bristolsdjb52j.jpg 223w", "/static/546c1c603cfde02b8227ea9f9debca40/f93b5/Sunset-behind-the-remaining-three-of-Bristolsdjb52j.jpg 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/546c1c603cfde02b8227ea9f9debca40/f93b5/Sunset-behind-the-remaining-three-of-Bristolsdjb52j.jpg",
                "alt": "Sunset behind the remaining three of Bristol's...",
                "title": "Sunset behind the remaining three of Bristol's...",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Sunset behind the remaining three of Bristol's...`}</figcaption>{`
  `}</figure></p>
    <p>{`Sometimes the idea does come from outside - like when somebody from `}<a parentName="p" {...{
        "href": "http://www.zemanta.com",
        "title": "Zemanta"
      }}>{`Zemanta`}</a>{` comes up to me and goes `}<em parentName="p">{`"Hey, I think you should write about this. And if you could also make product X look good, that'd be great"`}</em>{`. Or sometimes it's a friend saying `}<em parentName="p">{`"Hey, I just launched this cool thing/solved this cool problem/did something awesome ... can you write about it?"`}</em></p>
    <p>{`The idea goes on the whiteboard. Or in a moleskine. Anywhere.`}</p>
    <p>{`Yesterday I wrote a post for Zemanta (to be published later today). Here's what the process looked like:`}</p>
    <ol>
      <li parentName="ol">{`"Hey, write about This Thing (tm)."`}</li>
      <li parentName="ol">{`Install product, promise to give it a try`}</li>
      <li parentName="ol">{`3 days go by when I'm busy with other stuff`}</li>
      <li parentName="ol">{`"Hey, did you write anything yet? Just checking."`}</li>
      <li parentName="ol">{`Check out product, look at its homepage`}</li>
      <li parentName="ol">{`Go to bed thinking about the post`}</li>
      <li parentName="ol">{`Wake up, do an hour and a half`}{`_`}{` `}{`_`}{`of research on an unknown `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Problem_domain",
          "title": "Problem domain"
        }}>{`problem domain`}</a></li>
      <li parentName="ol">{`Go to class`}</li>
      <li parentName="ol">{`Ruminate on the post all day`}</li>
      <li parentName="ol">{`Come up with a few key phrases and points to mention`}</li>
      <li parentName="ol">{`Start writing ... decide I still don't know what I'm writing about`}</li>
      <li parentName="ol">{`Jot down three main points, organize them in a flow`}</li>
      <li parentName="ol">{`Spend two hours writing a `}<em parentName="li">{`very`}</em>{` crappy draft`}</li>
      <li parentName="ol">{`Watch an episode of futurama`}</li>
      <li parentName="ol">{`Rewrite the whole post in 20 minutes`}</li>
      <li parentName="ol">{`Congratulations, it is now 1:19am.`}</li>
    </ol>
    <p>{`While yesterday was a particularly crappy because I haven't been getting enough off-time lately, that's pretty much what goes into writing the kind of post that reliably makes it to The Frontpage (tm).`}</p>
    <p>{`Several rewrites from `}<em parentName="p">{`Wtf am I doing`}</em>{` to `}<em parentName="p">{`Hey, I can publish this ...`}</em>{` Each step also needs at least 20 minutes of slacking off before taking the next step.`}</p>
    <p>{`But I think it's worth it.`}</p>
    <p>{`Unfortunately, this is why the quality of my posts usually dips whenever a bunch of work is dumped in my lap. Double so if a deadline is attached to everything.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.contentmarketinginstitute.com/2012/02/federated-media-bloggers/"
        }}>{`Federated, Zemanta Launch Program to Connect Bloggers with Brands`}</a>{` (contentmarketinginstitute.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bloggingtips.com/2012/04/04/grow-a-blog-in-30-days/"
        }}>{`Grow A Blog In 30 Days - One Simple Idea Spark Up Your Blog!`}</a>{` (bloggingtips.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ayeshazahid.com/2012/04/04/inexperiencedor-youre-learning/"
        }}>{`inexperienced(or you're learning)`}</a>{` (ayeshazahid.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.factbrowser.com/2012/02/22/free-tools-to-make-blogging-easier/"
        }}>{`4 Free tools That Make Blogging So Much Easier`}</a>{` (factbrowser.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.newstatesman.com/blogs/media/2012/04/beauty-and-post-postbag-journalism"
        }}>{`Beauty and post-postbag journalism`}</a>{` (newstatesman.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://scarvesandcigarettes.wordpress.com/2012/04/02/ive-been-posting-these-in-the-wrong-blog/"
        }}>{`I've been posting these in the wrong blog...`}</a>{` (scarvesandcigarettes.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e6f46b5b-f41f-4e3b-a5de-161e3361ed67",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      